import { render } from "./ChangePassword.vue?vue&type=template&id=ff7a636a"
const script = {}
script.render = render

export default script